import { call, put, takeLatest } from "redux-saga/effects";
import { newRequest } from "../../../api/token";
import {
  getTransferCheckoutAction,
  getTransferListAction,
  getTransferPrebookAction,
  getTransferSearchAction,
} from "../../actions/transferActions";
import {
  GET_TRANSFER_CHECKOUT,
  GET_TRANSFER_LIST,
  GET_TRANSFER_PREBOOK,
  GET_TRANSFER_SEARCH,
} from "../../actionTypes/transferActionTypes";
import { TSApiPayloadInterface } from "../../../utils/helpers/interface";
import {
  GET_TRANSFER_CHECKOUT_WRAPPER,
  GET_TRANSFER_PREBOOK_WRAPPER,
  GET_TRANSFERSEARCH_WRAPPER,
  GET_TRANSFERSLIST_WRAPPER,
} from "../../gqlQueries/Dashboard/grnQuery";
import { getToken, getWrapperToken, isGlobalApolloError } from "../../../utils/helpers/auth";
import { getNotificationMessage } from "../../actions/localStorageActions";
import { UIMessage } from "../../../components/UI/UIMessage";

function* getTransferSearch(action: {
  type: string;
  payload: { payload: TSApiPayloadInterface; loader: any };
}): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`
    },
    transferSearchDTO: JSON.stringify(action?.payload?.payload),
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: GET_TRANSFERSEARCH_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      apiData?.data?.postTransfersSearch?.successTypeCode?.toLowerCase() ==
      "success" &&
      apiData?.data?.postTransfersSearch?.responseData?.status?.toLowerCase() ==
      "success"
    ) {
      action?.payload?.loader && action?.payload?.loader(false);
      yield put(
        getTransferSearchAction.FULLFILLED({
          data: apiData?.data?.postTransfersSearch?.responseData,
          status: 200,
        })
      );
    } else {
      action?.payload?.loader && action?.payload?.loader(false);
      yield put(getTransferSearchAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    yield put(getTransferSearchAction.REJECTED());
    const message = {
      isOpen: true,
      mainHeader: "System taking too long to load the results. Check your network and try again",
      subHeader: "",
      message: "",
      subReq: false,
    };
    yield put(getNotificationMessage(message));
  }
}

function* getTransfersList(action: {
  type: string;
  payload: { ts: string; setNoDataFlag: any; loader: any };
}): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    id: action?.payload.ts,
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_TRANSFERSLIST_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      apiData?.data?.transfersList?.successTypeCode?.toLowerCase() ==
      "success" &&
      apiData?.data?.transfersList?.responseData?.status?.toLowerCase() ==
      "success"
    ) {
      action?.payload?.loader && action?.payload?.loader(false);
      yield put(
        getTransferListAction.FULLFILLED({
          data: apiData?.data?.transfersList?.responseData,
          status: 200,
        })
      );
    } else {
      action?.payload?.loader && action?.payload?.loader(false);
      yield put(getTransferListAction.REJECTED());
      UIMessage({
        messageText: "No Transfers found.",
        closeIcon: true,
      });
      action?.payload?.setNoDataFlag && action?.payload?.setNoDataFlag(true);
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    yield put(getTransferListAction.REJECTED());
    UIMessage({
      messageText:
        "System taking too long to load the results. Check your network and try again.",
      closeIcon: true,
    });
    action?.payload?.setNoDataFlag && action?.payload?.setNoDataFlag(true);
  }
}

function* getTransferPrebook(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    transfersPrebookDTO: JSON.stringify(action?.payload?.apiPayload),
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: GET_TRANSFER_PREBOOK_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });
    if (
      apiData?.data?.postTransfersPrebook?.successTypeCode?.toLowerCase() ==
      "success" &&
      apiData?.data?.postTransfersPrebook?.responseData?.status?.toLowerCase() ==
      "success"
    ) {
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      yield put(
        getTransferPrebookAction.FULLFILLED({
          data: apiData?.data?.postTransfersPrebook?.responseData,
          status: 200,
        })
      );
    } else {
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      UIMessage({
        messageText: "Failed to generate Booking Id",
        closeIcon: true,
      });
      yield put(getTransferPrebookAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader && action?.payload?.setLoader(false);
    UIMessage({
      messageText:
        "System taking too long to load the results. Check your network and try again.",
      closeIcon: true,
    });
    yield put(getTransferPrebookAction.REJECTED());
  }
}

function* getTransferCheckout(action: any): any {
  if (action?.payload?.apiPayload) {
    // remove unnessary properties from payload
    const expectedproperties = {
      timelimit: "string",
      bookingID: "string",
      remarks: "string",
      paxes: [
        {
          firstname: "string",
          lastname: "string",
          middle_name: "string",
          company_name: 'string',
          passportNumber: "string",
          passportExpiry: "string",
          issueDate: "string",
          issuePlace: "string",
          issueCountry_code: "string",
          issueCountry: "string",
          age: 0,
          pan: "string",
          pax_id: Number,
        },
      ],
      agentref: "string",
      emergencycontactnumber: "string",
      agentname: "string",
      pickupTime: "string",
      returnTime: "string",
      chkagree: "string",
      chkagreeLERMS: "string",
      chkindemnify: "string",
      arrivalFrom: "string",
      arrivalAirline: "string",
      arrivalFlightNO: "string",
      returnFrom: "string",
      returnAirline: "string",
      returnFlightNO: "string",
      pickupFrom: "string",
      pickupFromCode: "string",
      dropOffTo: "string",
      dropOffToCode: "string",
    };

    // ----------------------> Create a new object with only the expected properties
    const filteredProperties = Object.keys(expectedproperties).reduce((acc, key) => {
      if (key in action?.payload?.apiPayload) {
        acc[key] = action?.payload?.apiPayload[key];
      }
      return acc;
    }, {} as { [key: string]: any })

    // Handle the paxes array separately
    filteredProperties.paxes = action?.payload?.apiPayload?.paxes.map((pax: any) => {
      return Object.keys(expectedproperties.paxes[0]).reduce((acc, key) => {
        if (key in pax) {
          (acc as any)[key] = pax[key];
        }
        return acc;
      }, {});
    });
    // ----------------------> Create a new object with only the expected properties

    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      input: JSON.stringify(filteredProperties),
      sid: action?.payload?.sid,
      hubSearchId: action?.payload?.hubSearchId || "",
    };

    try {
      const apiData = yield call(newRequest, {
        callType: "apollo",
        callMethod: "mutation",
        dataQuery: GET_TRANSFER_CHECKOUT_WRAPPER,
        clientType: "BE",
        data: customHeaders,
      });

      if (
        apiData?.data?.postTransfersCheckOut?.successTypeCode?.toLowerCase() ==
        "success" &&
        apiData?.data?.postTransfersCheckOut?.responseData?.status?.toLowerCase() ==
        "success"
      ) {
        action?.payload?.setLoader && action?.payload?.setLoader(false);
        action?.payload?.getCheckoutDetails?.(apiData?.data?.postTransfersCheckOut?.responseData?.data?.status?.toLowerCase());
        yield put(
          getTransferCheckoutAction.FULLFILLED({
            data: apiData?.data?.postTransfersCheckOut?.responseData,
            status: 200,
          })
        );
      } else {
        action?.payload?.setLoader && action?.payload?.setLoader(false);
        if (action?.payload?.callingFrom == "online") {
          setTimeout(() => {
            window.location.href = "/";
          }, 5000);
        }
        action?.payload?.getCheckoutDetails?.("pending");
        yield put(getTransferCheckoutAction.REJECTED());
      }
    } catch (error: any) {
      if (isGlobalApolloError(error)) return;
      if (action?.payload?.callingFrom == "online") {
        setTimeout(() => {
          window.location.href = "/";
        }, 5000);
      }
      action?.payload?.getCheckoutDetails?.("pending");
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      yield put(getTransferCheckoutAction.REJECTED());
    }
  }
}

export function* watcherTransfer() {
  yield takeLatest(GET_TRANSFER_SEARCH.STARTED, getTransferSearch);
  yield takeLatest(GET_TRANSFER_LIST.STARTED, getTransfersList);
  yield takeLatest(GET_TRANSFER_PREBOOK.STARTED, getTransferPrebook);
  yield takeLatest(GET_TRANSFER_CHECKOUT.STARTED, getTransferCheckout);
}

export const sagas = [watcherTransfer];
